import api from "./api";

export const getCurrentPrices = async (q: string, limit: number) => {
  return await api.get(`/prices-current?q=${q}&limit=${limit}`);
};
export const getCurrentPriceByBarcode = async (barcode: string) => {
  if (barcode) return await api.get(`/prices-current/barcode/${barcode}`);
};
export const getCurrentPriceByCategory = async (body: {
  q: string;
  categoryId: number | undefined;
  warehouseId: number
}) => {
  return await api.get(
    `/prices-current/category/${body.categoryId}?q=${body.q}&warehouseId=${body.warehouseId}`
  );
};
